// Controle de exposição da Escala de Enfermagem.
export const ESCALA_ENFERMAGEM_HABILITADA = true;

const normalizeProfileValue = (value = '') =>
	String(value || '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim();

const getPermissionName = (permission) => {
	if (typeof permission === 'string') return permission;
	return permission?.nome || permission?.codename || permission?.name || '';
};

export const isDeveloperUser = (user = {}) => {
	if (
		user?.desenvolvedor === true ||
		normalizeProfileValue(user?.cargo) === 'desenvolvedor'
	) {
		return true;
	}

	const permissions = Array.isArray(user?.permissao)
		? user.permissao
		: [user?.permissao].filter(Boolean);

	return permissions.some((permission) => {
		const normalized = normalizeProfileValue(getPermissionName(permission));
		return normalized === 'desenvolvedor' || normalized === 'desenvolvedores';
	});
};

const hasNamedPermission = (user = {}, permissionName = '') => {
	const target = normalizeProfileValue(permissionName);
	const permissions = Array.isArray(user?.permissao)
		? user.permissao
		: [user?.permissao].filter(Boolean);

	return permissions.some(
		(permission) => normalizeProfileValue(getPermissionName(permission)) === target,
	);
};

// A tela principal é consultiva e pode ser acessada por qualquer pessoa
// autenticada enquanto o recurso estiver habilitado.
export const canAccessEscalaEnfermagem = () => ESCALA_ENFERMAGEM_HABILITADA;

// As ações administrativas permanecem restritas à permissão de edição, com
// desenvolvedores mantendo o mesmo acesso administrativo da escala médica.
export const canManageEscalaEnfermagem = (user = {}) =>
	ESCALA_ENFERMAGEM_HABILITADA &&
	(isDeveloperUser(user) ||
		hasNamedPermission(user, 'EscalaEnfermagemEdicao'));
